<app-topnav></app-topnav>
<!-- HEADER -->
<app-header-secondary-h *ngIf="currentLang ==='fr'" [pageTitle]="'Cafétéria'" 
    [pageDescription]="['L’ingrédient essentiel pour améliorer', 'la gestion, la communication ainsi que le,', 'suivi et ce, sans manipulation d’argent']"
    [imageURL]="'assets/img/logiciels/CAFE_top.png'" ></app-header-secondary-h>
<app-header-secondary-h *ngIf="currentLang ==='en'" [pageTitle]="'Cafeteria'" 
    [pageDescription]="['The essential ingredient to improve the', 'quality of management, communication and', 'supervision, minus the handling of money']"
    [imageURL]="'assets/img/logiciels/CAFE_top.png'" ></app-header-secondary-h>
<!-- end HEADER -->

    <!-- SECTION characteristics -->
    <section id="section-characteristics">
        <div id="section-characteristics-inner">
            <div class="container">
                <div class="row">
                    <div class="col col-12" *ngIf="currentLang ==='fr'">
                        <h2 class="section-title">
                            <strong>Caractéristiques et avantages</strong>
                        </h2>
                        <p>Avec le module de la cafétéria, vous économiserez temps et argent, puisqu’il vous sera désormais possible de comptabiliser les produits à la pièce et débiter automatiquement vos clients via leur compte prépayé. Ce service, facile à utiliser, est synchronisé avec notre logiciel de gestion financière (FGF) et le Pluriportail. Une meilleure communication entre administrateurs, parents et élèves… la recette gagnante pour une gestion plus efficace.</p>
                    </div>
                    <div class="col col-12" *ngIf="currentLang ==='en'">
                            <h2 class="section-title">
                                <strong>Benefits and key features</strong>
                            </h2>
                            <p>With the cafeteria module, you save time and money. It is now possible to record items at piece rate and automatically debit your clients via their prepaid account. This service is easy to use and is synchronized with our financial management software (FGF) and with the Pluriportail. A better communication between the administrators, the parents and the students, what a winning formula to ensure the best management possible!</p>
                        </div>
                    </div>
    
                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_01.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Historique des achats de l’élève à la cafétéria.</p>
                                    <p *ngIf="currentLang ==='en'">History of the student’s purchases in the cafeteria.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_02.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Sécurité accrue en évitant la manipulation d’argent.</p>
                                    <p *ngIf="currentLang ==='en'">Improved security while avoiding any money manipulation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_03.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Facturation en temps réel avec une carte prépayée et un compte débité automatiquement.</p>
                                    <p *ngIf="currentLang ==='en'">Real-time billing with prepaid cards and automatic debit account .</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <img src="assets/img/pages/characteristics_04.svg" />
                            </div>
                            <div class="col-md-6">
                                <div class="content">
                                    <p *ngIf="currentLang ==='fr'">Facturation simplifiée pour la comptabilité.</p>
                                    <p *ngIf="currentLang ==='en'">Simplified billing for accounting purposes.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col col-12" *ngIf="currentLang ==='fr'">
                        <h2 class="section-title">
                            <strong>Des repas à la carte… prépayée !</strong>
                        </h2>
                        <p>À l’aide de leur carte de crédit, les parents déposent le montant de leur choix dans le compte de leur enfant sur le Pluriportail de l’école. L’élève dispose ensuite de l’argent pour se procurer des aliments à la cafétéria. Le solde de son compte est mis à jour automatiquement après chaque transaction. L’élève n’a plus besoin d’apporter de l’argent à l’école et les parents accèdent à un état de compte qui leur permet de mieux contrôler les achats. Découvrez les avantages du module de la cafétéria sans tarder!</p>
                    </div>
                    <div class="col col-12" *ngIf="currentLang ==='en'">
                            <h2 class="section-title">
                                <strong>À la carte meals… on a prepaid card!</strong>
                            </h2>
                            <p>By means of their credit card, the parents deposit the amount of their choice into their child’s account on the school Pluriportail. The student now has the money required to buy food at the cafeteria. The balance of his account will automatically decrease after each transaction. The student doesn’t need to bring money at school anymore. The parents have access to their account statement, which allows them to better control the food purchased. Discover the benefits of the cafeteria module!</p>
                        </div>
                    </div>
            </div>
        </div>
    </section>
    <!-- end SECTION characteristics -->
    
<!-- SECTION - taquets -->
<app-taquets *ngIf="currentLang ==='fr'" #ref [title]="taquets.title" [description]="taquets.description" [items]="taquets.items">
    <div class="taquets-slides">
        <div class="taquets-slide" [class.active]="ref.selected === 0">

            <h2 class="section-title"><strong>Implantation</strong></h2>
            <p>Le module de la cafétéria est facile à implanter, car vous avez peu de configurations à effectuer. Plurilogic s’occupe des démarches et vous offre du soutien pour une implantation réussie. Ainsi, tous vos usagers seront en mesure d’utiliser ce module de façon optimale.</p>
                    
        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 1">

            <h2 class="section-title"><strong>Utilisation</strong></h2>
            <p>Nous avons développé le module de la cafétéria dans le but d’aider les gestionnaires, les parents et les élèves. Ainsi, effectuer l’inventaire des aliments et procéder à la facturation de tous les usagers sont maintenant des opérations plus simples. Quant à la carte prépayée, elle offre plus de sécurité en éliminant l’argent comptant et permet une meilleure supervision des transactions enregistrées en temps réel dans un compte sur le Pluriportail.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 2">

            <h2 class="section-title"><strong>Gestion</strong></h2>
            <p>Oubliez la comptabilité papier et passez en mode virtuel! En plus de gérer efficacement tous les aspects de la cafétéria, vous réduirez les ambiguïtés avec les parents. En outre, la fonctionnalité ajoutée pour les élèves ayant des allergies alimentaires assurera une meilleure sécurité à la cafétéria de votre école.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 3">

            <h2 class="section-title"><strong>Planification</strong></h2>
            <p>Le système de planification des repas rend un fier service aux parents et aux gestionnaires qui peuvent maintenant prévoir les quantités d’aliments nécessaires à la composition du menu. Les parents ont également la possibilité d’ajouter des repas de dernière minute.</p>

        </div>
    </div>
</app-taquets>
<app-taquets *ngIf="currentLang ==='en'" #ref [title]="taquets.titleEN" [description]="taquets.descriptionEN" [items]="taquets.itemsEN">
    <div class="taquets-slides">
        <div class="taquets-slide" [class.active]="ref.selected === 0">

            <h2 class="section-title"><strong>Implementation</strong></h2>
            <p>The cafeteria module is easy to set up. You don’t need to do that much in terms of configuration. Plurilogic takes charge of the procedures and provides you with the necessary support. Then, as soon as the module is successfully implemented, all the users are able to use it in an optimal way.</p>
                    
        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 1">

            <h2 class="section-title"><strong>Usage</strong></h2>
            <p>We have developed the cafeteria module in order to help the managers, the parents and the students. The supervision of the food inventory is simpler as is the process of billing all the users. As for the prepaid card, it allows to get rid of cash money for improved security level and a better supervision of transactions, which are registered in real time in an account created on the Pluriportail.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 2">

            <h2 class="section-title"><strong>Management</strong></h2>
            <p>Forget about the paper-based accounting, enter into virtual mode! In addition of ensuring efficient management of all that concerns your school cafeteria, you won’t have to deal with ambiguities with the parents. Moreover, the food allergy function ensures the safety of all students attending your school’s cafeteria.</p>

        </div>
        <div class="taquets-slide" [class.active]="ref.selected === 3">

            <h2 class="section-title"><strong>Planning </strong></h2>
            <p>The meal planning system is very useful for the parents and school managers, since they are now in a position to foresee the appropriate amount of food that is required in meal preparation. Parents have also the opportunity to add last-minute meals.   </p>

        </div>
    </div>
    </app-taquets>
    <!-- end SECTION - taquets -->
    
    <p>&nbsp;</p>
    <p>&nbsp;</p>

<app-footer></app-footer>
    